export const config = {
  title: 'Alex & Crew Siding LLC',
  meta: {
    description:
      'Alex & Crew Siding LLC offers professional siding installation and repair services in Buffalo, NY, ensuring quality craftsmanship and customer satisfaction.',
    keywords: [
      'Siding Services',
      'Siding Installation',
      'Siding Repair',
      'Buffalo NY Siding',
      'Alex & Crew Siding LLC',
    ],
    author: 'Alex & Crew Siding LLC',
    canonicalUrl: 'https://www.alexncrewsidingllc.com/',
  },
  sections: {
    header: {
      businessName: 'Alex & Crew Siding LLC',
    },
    sectionB: {
      heroTitle: 'Alex & Crew Siding LLC',
      heroSubtitle: 'Professional Siding Services in Buffalo, NY',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '+14072834077',
      phoneLabel: '(407) 283-4077',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/172628686/photo/two-men-applying-green-paneling-to-a-house.jpg?s=612x612&w=0&k=20&c=fQr8PudOM3ZYFPIsIKcGeHUqQtZfUbIxQHjWyGnvBBA=',
      cardData: [
        {
          title: 'Expert Craftsmanship',
          description:
            'Our team delivers top-quality siding installations and repairs with attention to detail.',
        },
        {
          title: 'Customer Satisfaction',
          description:
            'We prioritize your satisfaction, ensuring each project meets your expectations.',
        },
        {
          title: 'Affordable Pricing',
          description:
            'We offer competitive pricing without compromising on quality.',
        },
      ],
      description:
        'At Alex & Crew Siding LLC, we specialize in siding installations and repairs, providing services to enhance the beauty and durability of your home.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional siding services designed to meet your needs.',
      cards: [
        {
          title: 'Siding Installation',
          description:
            'Professional installation of various siding materials to enhance your home’s exterior.',
          imageSrc: 'https://media.istockphoto.com/id/852634926/photo/installation-of-siding.jpg?s=612x612&w=0&k=20&c=XFczuYIQ7Z9JzBLlBEGUasb8j8ZiOhB0VPUEWSXl4gk=',
          imageAlt: 'Siding Installation',
        },
        {
          title: 'Siding Repair',
          description:
            'Expert repair services to maintain the integrity and appearance of your siding.',
          imageSrc: 'https://media.istockphoto.com/id/147044583/photo/man-installing-siding.jpg?s=612x612&w=0&k=20&c=0cZLs1GtSuSUcIs_8rDS7MOrWUDdYeUG4M4aKvCXD48=',
          imageAlt: 'Siding Repair',
        },
        {
          title: 'Siding Replacement',
          description:
            'Comprehensive siding replacement services to upgrade and protect your home.',
          imageSrc: 'https://media.istockphoto.com/id/146731657/photo/carpenter-installing-siding.jpg?s=612x612&w=0&k=20&c=wa5i5J0JePZyBQl81ba4qUvBmfcs2mShGYnY-ry9NCk=',
          imageAlt: 'Siding Replacement',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Vinyl Siding',
        'Fiber Cement Siding',
        'Wood Siding',
        'Metal Siding',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://media.istockphoto.com/id/184870224/photo/new-home-showing-vinyl-siding-roof.jpg?s=612x612&w=0&k=20&c=_9K_Jx360D0q-XI55M_RQJnslfh9sYCjuc5B7-YSSA4=',
        alt: 'Alex & Crew Siding LLC Team',
      },
      aboutText: [
        'Alex & Crew Siding LLC is a locally owned and operated business in Buffalo, NY, dedicated to providing high-quality siding services.',
        'With years of experience, our team is committed to enhancing the aesthetics and durability of your home through exceptional siding solutions.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'Alex & Crew Siding LLC Logo',
      businessName: 'Alex & Crew Siding LLC',
      contact: {
        phone: '+14072834077',
        phoneLabel: '(407) 283-4077',
        email: 'alexncrewsidingllc@gmail.com',
        website: 'https://www.alexncrewsidingllc.com/',
        address: 'Buffalo, NY',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: 'Buffalo, NY',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23878.642943524276!2d-78.8783685!3d42.8864468!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d31234567890ab%3A0xcdef1234567890ab!2sBuffalo%2C%20NY!5e0!3m2!1sen!2sus!4v1710412345678!5m2!1sen!2sus',
    },
  },
};

export default config;
